import React from "react"
import { Outlet } from "react-router-dom"
import { Navbar } from "../components/Navbar"
import { WebsiteFooter } from "../components/WebsiteFooter"

export const WebsiteLayout: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <WebsiteFooter />
    </div>
  )
}
